import { render, staticRenderFns } from "./SingleSignOn.vue?vue&type=template&id=25adf6e8&scoped=true&"
import script from "./SingleSignOn.vue?vue&type=script&lang=js&"
export * from "./SingleSignOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25adf6e8",
  null
  
)

export default component.exports